const experiences = [
    {
        id: "brainrocket",
        title: "BrainRocket",
        left: "BrainRocket 2025 - Present",
        role: "Lead Unity Software Engineer",
        right: "Lead Unity Software Engineer",
        location: "Limassol, CY",
        website: "https://www.brainrocket.com",
        duration: "June 2025 - Present",
        image: "/images/bro_logo.png",
        parallax1: -35,
        parallax2: 35,
        link: "/experience/brainrocket",
        more: [
            "Lead Unity client engineering for a new mobile game while staying hands-on with production code and technical direction.",
            "Develop real-time PvP client systems with WebSockets, coordinating live game state with backend services.",
            "Build modular systems for profiles, accounts, battle pass, shop, customization, game modes, Firebase, REST communication, and server-driven flows.",
            "Own architecture, code quality, code reviews, task breakdown, mentoring, and release-focused editor/configuration tooling.",
            "Create native iOS/Android integration layers for platform capabilities, secure storage, haptics, and cloud data.",
        ],
    },
    {
        id: "fmgames",
        title: "FM-GAMES",
        left: "FM-GAMES 2021 - 2025",
        role: "Senior Unity Software Engineer",
        right: "Senior Unity Software Engineer",
        location: "Limassol, CY",
        website: "https://www.fm-games.com",
        duration: "April 2021 - June 2025",
        image: "/images/fmgames.jpeg",
        parallax1: -50,
        parallax2: 50,
        link: "/experience/fmgames",
        more: [
            "Progressed from Junior to Senior Unity engineer while working across a portfolio of 15+ live mobile card, board, word, and puzzle games for iOS and Android.",
            "Delivered new games, live features, bug fixes, SDK integrations, platform-specific improvements, release support, and production issue resolution.",
            "Built and maintained reusable Unity systems, internal tools, native iOS/Android packages, and third-party library integrations used across multiple projects.",
            "Profiled and optimized mobile performance, stability, loading behavior, and scalability for live products.",
            "Improved development workflows, code quality, and team productivity through tooling, reviews, technical ownership, and cross-functional collaboration.",
        ],
    },
    {
        id: "nosebleed",
        title: "Nosebleed Interactive",
        left: "Nosebleed Interactive 2020 - 2021",
        role: "Unity Software Engineer",
        right: "Unity Software Engineer",
        location: "Newcastle, UK",
        website: "https://www.nosebleedinteractive.com",
        duration: "April 2020 - April 2021",
        image: "/images/nodeBleed.png",
        parallax1: -100,
        parallax2: 100,
        link: "/experience/nosebleed",
        more: [
            {
                parts: [
                    "Core credited developer on ",
                    {
                        label: "Arcade Paradise",
                        href: "https://store.steampowered.com/app/1388870/Arcade_Paradise/",
                    },
                    " for PC and consoles, contributing gameplay systems and Unity architecture within a multidisciplinary team.",
                ],
            },
            "Built deep Unity knowledge by working across multiple game genres, gameplay loops, input models, content pipelines, and player expectations.",
            "Improved shipping-quality Unity practices through debugging, feature integration, and close iteration with designers and artists.",
        ],
    },
    {
        id: "xamplifier",
        title: "XAmplifier",
        left: "XAmplifier 2018",
        role: "Full-Stack Engineer Intern",
        right: "Full-Stack Engineer Intern",
        location: "Limassol, CY",
        website: "https://www.xamplifier.com",
        duration: "June 2018 - September 2018",
        image: "/images/xampLogo.png",
        parallax1: -50,
        parallax2: 50,
        link: "/experience/xamplifier",
        more: [
            "Built and improved customer-facing analytics website features, working across frontend/backend code and data-driven UI.",
            "Supported transaction and user-flow improvements, gaining production web/API experience.",
        ],
    },
];

export default experiences;
